import { isNotNullish } from '@y42/util/nullish';
import { setupToolLifecycleListeners } from './setup-tool-lifecycle-listeners';
import { withoutUndoManager } from './without-undo-manager';

export const toggleTextOnTextEditing = (diagram: go.Diagram, categoryName: string, propertyName?: string) => {
  const tool = diagram.toolManager.textEditingTool;
  const transparent = 'transparent';
  let prevStroke: go.BrushLike | null = null;
  setupToolLifecycleListeners(
    tool,
    () => {
      prevStroke = tool.textBlock?.stroke === transparent ? prevStroke : tool.textBlock!.stroke;
      if (tool.textBlock?.part?.category === categoryName) {
        withoutUndoManager(diagram, () => {
          if (tool.textBlock) {
            tool.textBlock.stroke = transparent;
          }
        });
      }
    },
    () => {
      withoutUndoManager(diagram, () => {
        if (isNotNullish(prevStroke) && tool.textBlock) {
          tool.textBlock.stroke = propertyName ? tool.textBlock.part?.data[propertyName] || prevStroke : prevStroke;
        }
      });
    },
  );
};
